import React from 'react';
import PointsBasicIcon from '@assets/icons/toast/pointsBasic.svg';
import PointsBonusIcon from '@assets/icons/toast/pointsBonus.svg';
import StarBasicIcon from '@assets/icons/toast/starBasicFilled.svg';
import StarBonusIcon from '@assets/icons/toast/starBonusFilled.svg';
import type { TOAST_TYPE } from '@utils/toast.tsx';
import { getToastIcon } from '@utils/toast.tsx';

import {
    Description,
    IconWithTitle,
    InfoSection,
    Points,
    PointsPill,
    PointsToastDescription,
    PointsToastWrapper,
    Title,
    ToastInnerWrapperNoTitle,
    ToastInnerWrapperTitle,
    ToastWrapper,
} from './styled.tsx';

interface PointsToastProps {
    title: string;
    description: string;
    points: number;
    isBonus?: boolean;
}

interface GeneralToastProps {
    title: React.ReactNode | null;
    description: React.ReactNode;
    type: (typeof TOAST_TYPE)[keyof typeof TOAST_TYPE];
}

export const PointsToast: React.FC<PointsToastProps> = ({ title, description, points, isBonus = false }) => (
    <PointsToastWrapper>
        {isBonus ? <PointsBonusIcon /> : <PointsBasicIcon />}
        <InfoSection>
            <Title>{title}</Title>
            <PointsToastDescription>{description}</PointsToastDescription>
        </InfoSection>
        <PointsPill $isBonus={isBonus}>
            {isBonus ? <StarBonusIcon /> : <StarBasicIcon />}
            <Points>+{points}</Points>
        </PointsPill>
    </PointsToastWrapper>
);

export const Toast: React.FC<GeneralToastProps> = ({ title, description, type }) => (
    <ToastWrapper>
        {title ? (
            <ToastInnerWrapperTitle>
                <IconWithTitle>
                    {getToastIcon(type)}
                    {title}
                </IconWithTitle>
                <Description>{description}</Description>
            </ToastInnerWrapperTitle>
        ) : (
            <ToastInnerWrapperNoTitle>
                {getToastIcon(type)}
                <Description>{description}</Description>
            </ToastInnerWrapperNoTitle>
        )}
    </ToastWrapper>
);
